import { Button, Typography } from "@material-ui/core";
import Checkbox from "@saleor/components/Checkbox";
import MyTypography from "@saleor/components/MyTypography";
import React from "react";
import { useIntl } from "react-intl";

import InfoIcon from "../../../../assets/images/info-outline.svg";
import useStyles from "./styles";

interface EmptyProps {
  loading?: boolean;
}

const EmptyProduct: React.FC<EmptyProps> = () => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h6" className={classes.title}>
          {intl.formatMessage({
            defaultMessage: "รายละเอียดสินค้า"
          })}
        </Typography>
      </div>
      <div className={classes.subHeader}>
        <MyTypography variant="subtitle2" className={classes.subTitle}>
          <span className={classes.normalText}>มีทั้งหมด</span> 0{" "}
          <span className={classes.normalText}>รายการ</span>
        </MyTypography>
        <div className={classes.selectDivHeader}>
          <div className={classes.selectDivLeftEmpty}>
            <Checkbox size={"small"} checked={false} />
            <MyTypography
              variant="subtitle3"
              className={classes.subTitleDisable}
            >
              <span className={classes.normalText}>เลือกลบ</span> 0{" "}
              <span className={classes.normalText}>รายการ</span>
            </MyTypography>
          </div>
          <Button variant={"outlined"} color={"primary"} disabled>
            <MyTypography variant="body3" className={classes.txtDisable}>
              ลบรายการสินค้าที่เลือก
            </MyTypography>
          </Button>
        </div>
        <div className={classes.subBody}>
          <img src={InfoIcon} alt="" />
          <MyTypography variant="body3" style={{ color: "#555555" }}>
            ไม่มีสินค้าในคำสั่งซื้อนี้
          </MyTypography>
        </div>
      </div>
    </div>
  );
};

export default EmptyProduct;
